export enum MalwareScanResultType {
    Pending = "Pending",
    NoThreatsFound = "NoThreatsFound",
    Malicious = "Malicious",
    NotScanned = "NotScanned"
}

type Attachment = {
    id: number;
    sequenceIdentifier: string;
    fileName: string;
    fullFileName: string;
    scanResult: MalwareScanResultType;
    isDownloadPreventionEnabled: boolean;
    canDownload: boolean;
};

export default Attachment;
